// removed by extract-text-webpack-plugin
module.exports = {"RoundButton":"RoundButton__1LlbJ"};